import React, { useCallback, useEffect, useState } from "react";
import { DomainValue } from "../../services/mdmService/types";
import { getMDMConfiguration } from "../../services/mdmService/mdmService";
import "../../components/dataUploadLayout/dataUploadScreenLayout.css";
import { Box } from "@mui/material";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { useNavigate } from "react-router-dom";
import { LogEntity } from "../../components/logsAndReports/reportAndLogsRowTypes";
import MDMstudioLogs from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/logsScreen/logsScreen";
import { EditTable } from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/viewAndEdit/editTable";
import StudioRoleDivision from "../../components/dataUploadLayout/dataUploadHomeScreen/roleDivision/studioRoleDivision";
import UpdatedExcelUploadParentScreen from "./UpdatedExcelUploadParent";
import { useSelector } from "react-redux";
import { getMetaDataConfig, getUserRolesBasedOnAccess, isRoleConfigEnabled } from "../../services/uiConfigService";
import { updateCards,setFormConfig } from "../../stateManagement/actions/mdmDashboard";
import { initialCards,formConfig } from "./mdmUtils";
import { Loader } from "../../components/loader/Loader";
import store from "../../stateManagement/store";

export interface DataUploadScreenPropsTypes {
  handleStepIconClick?: (stepNumber: number) => void;
  currentStep?: number;
  completed?: {
    [k: number]: boolean;
  };
  setCompleted?: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  disableNext?: boolean;
}

export default function UpdatedMDM(
  props: DataUploadScreenPropsTypes
) {
  const cards = useSelector((state: any) => state.mdmDashboardReducer.cards);
  const [mdmData, setMdmData] = useState<DomainValue[]>([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [completed, setCompleted] = useState<{ [k: number]: boolean }>({});
  const [currentScreen, setCurrentScreen] = useState<
    "default" | "logs" | "edit" | "division" | "integration"
  >("default");
  const [curData, setData] = useState<LogEntity[]>([]);
  const [filteredData, setFilteredData] = useState<LogEntity[]>([]); // To store the search results
  const [selectedMaster, setSelectedMaster] = useState<DomainValue>();
  const [formConfigLoading, setFormConfigLoading] = useState(true);
  const [cardsLoading, setCardsLoading] = useState(true);
  const [showBeatMapping, setShowBeatMapping] = useState(false);

  const mdmState = useSelector(() => store.getState()?.mdmDashboardReducer?.currentMdmEntity)


  useEffect(() => {
    const fetchInitialCards = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
        const userRole = userData.designation;
        const roleDomainType = userRole === "admin" ? "admin_generic_mdm_configuration" : `${userRole}_generic_mdm_configuration`;
        const response = await getMetaDataConfig("clientconfig", roleDomainType);
        if (response && response?.domainValues && response?.domainValues?.length > 0) {
          const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
          const isAdmin = currentUserData.designation.includes("admin");
          const clientConfig = await getMetaDataConfig("clientconfig");
          if (isAdmin) {
            const configName = "admin_mdm";
            const mdmConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
            if (mdmConfig && Array.isArray(mdmConfig.domainValues)) {
              const allowedCardIds = mdmConfig.domainValues.map((entry: { id: string }) => entry.id);
              if (allowedCardIds.length > 0) {
                const genericMdm = response.domainValues ?? initialCards;
                const filteredCards = genericMdm.filter((card: { id: string }) =>
                  allowedCardIds.includes(card.id)
                );
                if(allowedCardIds.includes("beatMapping")){
                  setShowBeatMapping(true);
                }
                setMdmData(filteredCards);
              }
              else {
                setMdmData(response.domainValues ?? initialCards);
                setShowBeatMapping(true);
              }
            } else {
              setMdmData(response.domainValues);
              setShowBeatMapping(true);
            }
          } else {
             let allAllowedIds: string[] = [];

            const roleBasedAccess = isRoleConfigEnabled(clientConfig);
            const roles = getUserRolesBasedOnAccess(roleBasedAccess, currentUserData);

            for (let role of roles) {
              const configName = `${role}_mdm`;
              const roleMdmConfig = clientConfig.find(
                (config: { domainType: string }) => config.domainType === configName
              );

              if (roleMdmConfig?.domainValues && Array.isArray(roleMdmConfig.domainValues)) {
                const ids = roleMdmConfig.domainValues.map((entry: { id: string }) => entry.id);
                allAllowedIds = [...allAllowedIds, ...ids];
              }
            }

            const uniqueAllowedIds = Array.from(new Set(allAllowedIds));
           

            if (uniqueAllowedIds.length > 0) {
              const filteredCards = response.domainValues.filter((card: { id: string }) =>
                uniqueAllowedIds.includes(card.id)
              );
              if(uniqueAllowedIds.includes("beatMapping")){
                setShowBeatMapping(true);
              }
              setMdmData(filteredCards);
            } else {
              setMdmData([]);
            }
          }
          updateCards(response.domainValues);
        } else {
          const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
          const isAdmin = currentUserData.designation.includes("admin");
          const clientConfig = await getMetaDataConfig("clientconfig");
          if (isAdmin) {
            const configName = "admin_mdm";
            const mdmConfig = clientConfig.find((config: { domainType: string }) => config.domainType === configName);
            if (mdmConfig && Array.isArray(mdmConfig.domainValues)) {
              const allowedCardIds = mdmConfig.domainValues.map((entry: { id: string }) => entry.id);
              if (allowedCardIds.length > 0) {
                const filteredCards = initialCards.filter((card: { id: string }) =>
                  allowedCardIds.includes(card.id)
                );
                setMdmData(filteredCards);
              } else {
                setMdmData(initialCards);
              }
            } else {
              setMdmData(initialCards);
            }
          } else {
            let allAllowedIds: string[] = [];

            const roleBasedAccess = isRoleConfigEnabled(clientConfig);
            const roles = getUserRolesBasedOnAccess(roleBasedAccess, currentUserData);

            for (let role of roles) {
              const configName = `${role}_mdm`;
              const roleMdmConfig = clientConfig.find(
                (config: { domainType: string }) => config.domainType === configName
              );

              if (roleMdmConfig?.domainValues && Array.isArray(roleMdmConfig.domainValues)) {
                const ids = roleMdmConfig.domainValues.map((entry: { id: string }) => entry.id);
                allAllowedIds = [...allAllowedIds, ...ids];
              }
            }

            const uniqueAllowedIds = Array.from(new Set(allAllowedIds));

            if (uniqueAllowedIds.length > 0) {
              const filteredCards = response.domainValues.filter((card: { id: string }) =>
                uniqueAllowedIds.includes(card.id)
              );
              setMdmData(filteredCards);
            } else {
              setMdmData([]);
            }
          }
          updateCards(initialCards);
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
      } finally {
        setCardsLoading(false);
      }
    };
    fetchInitialCards();
  }, []);

  useEffect(() => {
    const fetchInitialFormConfig = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
        const userRole = userData.designation;
        const roleDomainType = userRole === "admin" ? "admin_form_configuration" : `${userRole}_form_configuration`;
        const response = await getMetaDataConfig("clientconfig", roleDomainType);
        if (response?.domainValues?.length > 0) {
          setFormConfig(response.domainValues);
        } else {
          setFormConfig(formConfig);
        }
      } catch (error) {
        console.error("Error fetching formConfig:", error);
      } finally {
        setFormConfigLoading(false);
      }
    };
    fetchInitialFormConfig();
  }, []);

  

  const loading = cardsLoading || formConfigLoading;

  useEffect(() => {
    if(mdmState){
        const currentMDM:DomainValue|undefined = mdmData.find((obj:DomainValue)=> obj&&obj.id === mdmState.id);
        setSelectedMaster(currentMDM);
    }
    else{
        setSelectedMaster(mdmData[0]);
    }
  }, [mdmData]);
  useEffect(() => {
    if (currentScreen === "integration" && currentStep !== 1) {
      setCurrentStep(1);
    } else if (currentScreen === "default" && currentStep !== 0) {
      setCurrentStep(0);
    }
  }, [currentScreen, currentStep]);

  const getLogs = useCallback(async () => {
    const Url = getUrl(selectedMaster?.entityName ?? "All");
    const entityData = await ChannelkartNetworkGet(Url);
    const logs = entityData.data.features.filter(
      (log: any) => log.response !== undefined
    );
    setData(logs);
    setFilteredData(logs); // Initially set filtered data as the full data set
  }, [selectedMaster]);

  function getUrl(entity: string) {
    if (entity && entity !== "All") {
      return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload'] and attributes.entityName:${entity}&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
    } else {
      return `/tasks/data?filter=type[in]:['blobcreater','mdmupload','mdmkafkaupload']&sort=creationTime:desc&size=100&source=portal&callType=scheduled`;
    }
  }

  useEffect(() => {
    getLogs();
  }, [selectedMaster]);
  const handleStepIconClick = (stepNumber: number) => {
    if (stepNumber === 0) {
      handleScreenSwitch("default");
    } else if (stepNumber === 1) {
      handleScreenSwitch("integration");
    }
    setCurrentStep(stepNumber);
  };
  const handleScreenSwitch = (
    screen: "default" | "logs" | "edit" | "division" | "integration"
  ) => {
    setCurrentScreen(screen);
  };



  const renderExcelUploadScreen = () => {
    switch (currentScreen) {
      case "default":
        return (
          <div className="excel-container">
                <span style={{
                    textAlign: 'left',
                    font: 'normal normal 600 16px/34px Poppins',
                    letterSpacing: '0px',
                    color: '#227c9d',
                    opacity: 1,
                    marginLeft: '30px'
                }}>
                    Masters
                </span>

            <p style={{ marginLeft: "30px" }}>
              Effortlessly integrate your data by uploading your master files.
            </p>
            <h4>Let's Get Started</h4>
            <UpdatedExcelUploadParentScreen
              handleStepIconClick={handleStepIconClick}
              currentStep={0}
              completed={completed}
              setCompleted={setCompleted}
              mdmData={mdmData}
              showBeatMapping={showBeatMapping}
              setMdmData={setMdmData}
              handleScreenSwitch={handleScreenSwitch}
              selectedMaster={selectedMaster}
              setSelectedMaster={setSelectedMaster}
              curData={curData}
              filteredData={filteredData}
              getLogs={getLogs}
              isNextDisabled={true}
            />
          </div>
        );
      case "logs":
        return (
          <Box sx={{ position: "relative", height: "100%", width: "100%" }}>
            <MDMstudioLogs
              currentMaster={selectedMaster}
              handleScreenSwitch={handleScreenSwitch}
              headingTitle={"See logs"}
              curData={curData}
              setData={setData}
              filteredData={filteredData}
              setFilteredData={setFilteredData}
            />
          </Box>
        );
      case "edit":
        return (
          <Box sx={{ position: "relative", height: "80vh", width: "100%" }}>
            <EditTable
              selectedMaster={selectedMaster}
              handleScreenSwitch={handleScreenSwitch}
              headingTitle={`Edit a record for ${selectedMaster?.name}`}
            />
          </Box>
        );
      case "division":
        return (
          <Box
            sx={{
              position: "relative",
              height: "80vh",
              width: "100%",
              overflow: "scroll",
            }}
          >
            <StudioRoleDivision handleScreenSwitch={handleScreenSwitch} />
          </Box>
        );

      default:
        return null;
    }
  };


  if (loading) {
    return (
     <Loader/>
    );
  }
  return (
    <>
      {showErrorMessage ? (
        <div className="mdm-error">
          <div className="mdm-card-error-msz">
            {" "}
            Cards are not available for Now, Kindly refresh
          </div>
        </div>
      ) : (
          <div className="mdm-screen">
            {(mdmData.length === 0 && !showBeatMapping) ? <div className="mdm-card-error-msz">
            Cards are not available
          </div> : renderExcelUploadScreen()}
          </div>
      )}
    </>
  );
}
